export * from '@trpc/client';
import { c as createReactQueryUtils, a as createQueryUtilsProxy } from './utilsProxy-5402e992.mjs';
export { g as getQueryKey } from './utilsProxy-5402e992.mjs';
import { createFlatProxy } from '@trpc/core';
import { useMemo } from 'react';
import { c as createRootHooks, a as createReactDecoration, b as createUtilityFunctions } from './createHooksInternal-df9ecb1f.mjs';
import '@tanstack/react-query';

/**
 * @internal
 */ function createHooksInternal(trpc) {
    return createFlatProxy((key)=>{
        if (key === 'useContext' || key === 'useUtils') {
            return ()=>{
                const context = trpc.useUtils();
                // create a stable reference of the utils context
                return useMemo(()=>{
                    return createReactQueryUtils(context);
                }, [
                    context
                ]);
            };
        }
        if (trpc.hasOwnProperty(key)) {
            return trpc[key];
        }
        return createReactDecoration(key, trpc);
    });
}
function createTRPCReact(opts) {
    const hooks = createRootHooks(opts);
    const proxy = createHooksInternal(hooks);
    return proxy;
}

function createTRPCQueryUtils(opts) {
    const utils = createUtilityFunctions(opts);
    return createQueryUtilsProxy(utils);
}

export { createTRPCQueryUtils, createTRPCReact };
